import styled from 'styled-components'

export default styled.div`
  font-size: 17px;
  line-height: 26px;
  color: white;
  margin: 20px 0;
  font-weight: 300;
`



// WEBPACK FOOTER //
// ./src/pages/Landing/Paragraph.js